import type { ResponsiveIconSize } from "@/shared/ui/actions/GenericIcon";

export const ICON_SIZE_MENU_ITEM = Object.freeze({
  base: "md",
  md: "xs",
} as ResponsiveIconSize);

export const ICON_SIZE_ACTION_BUTTON = Object.freeze({
  base: "lg",
  md: "md",
} as ResponsiveIconSize);

export const ICON_SIZE_TOUCH_TARGET = Object.freeze({
  base: "lg",
  md: "sm",
} as ResponsiveIconSize);

export const ICON_SIZE_CHIP_ACTION = Object.freeze({
  base: "md",
  md: "sm",
} as ResponsiveIconSize);

export const ICON_SIZE_TOOLBAR = Object.freeze({
  base: "md",
  md: "sm",
} as ResponsiveIconSize);

export const ICON_SIZE_INLINE = "xs" as ResponsiveIconSize;

export const ICON_SIZE_DECORATIVE = Object.freeze({
  base: "md",
  md: "lg",
} as ResponsiveIconSize);

export const ICON_SIZE_SWIPE_ACTION = Object.freeze({
  base: "md",
  sm: "md",
  md: "lg",
} as ResponsiveIconSize);

export const iconSizePresets = Object.freeze({
  menuItem: ICON_SIZE_MENU_ITEM,
  actionButton: ICON_SIZE_ACTION_BUTTON,
  touchTarget: ICON_SIZE_TOUCH_TARGET,
  chipAction: ICON_SIZE_CHIP_ACTION,
  toolbar: ICON_SIZE_TOOLBAR,
  inline: ICON_SIZE_INLINE,
  decorative: ICON_SIZE_DECORATIVE,
  swipeAction: ICON_SIZE_SWIPE_ACTION,
});

export type IconSizePreset = keyof typeof iconSizePresets;

export default iconSizePresets;
